module.exports = __webpack_public_path__ + "img/spotify.3b29c221.png";